import { ExternalUserRegistration } from './external-user-registration';

export class ExternalUserRegistrationActionPayload {
  list?: ExternalUserRegistration[] = [];

  item?: ExternalUserRegistration = new ExternalUserRegistration();
}
